
























import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalName from '@/utils/ModalName'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import FormError from '@/components/reusable-components/form/FormError.vue'
import { ButtonTheme } from '@/utils/ButtonAttr'

@Component({
    components: { FormError, BaseButton },
})
export default class ModalDeviceError extends Vue {
    @Prop({ type: String, default: ModalName.DEVICE_ERROR }) name!: ModalName

    ButtonTheme: typeof ButtonTheme = ButtonTheme

    close() {
        this.$modal.hide(this.name)
    }
}
